import axios from "axios";
import { apiCall } from "./ApiResult.model";

export const markEventHandled = apiCall<string, boolean>(
  "events.mark",
  async (eventId) => {
    await axios.put(
      `/event-marker/mark-event/event/${encodeURIComponent(eventId)}`
    );
    return {
      success: true,
      value: true,
    };
  }
);

export const unmarkEventHandled = apiCall<string, boolean>(
  "events.unmark",
  async (eventId) => {
    await axios.delete(
      `/event-marker/mark-event/event/${encodeURIComponent(eventId)}`
    );
    return {
      success: true,
      value: true,
    };
  }
);
